import { render, staticRenderFns } from "./Psychologists.vue?vue&type=template&id=0716bc01&scoped=true"
import script from "./Psychologists.vue?vue&type=script&lang=js"
export * from "./Psychologists.vue?vue&type=script&lang=js"
import style0 from "./Psychologists.vue?vue&type=style&index=0&id=0716bc01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716bc01",
  null
  
)

export default component.exports